import { Post } from './Post';
import { IObject3D } from '../../Interfaces';
import { EmptyRect } from './EmptyRect';

declare const THREE: any;

export class TextPost extends Post {

  static readonly Name = 'textPost';

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));
  type: any;
  labelPos: any;

  constructor(type, labelPos) {
    super();
    this.type = type;
    this.labelPos = labelPos;

    const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(TextPost.rotationTransform);
    const material = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, transparent: true });

    let mesh = new THREE.Mesh(geometry, material);
    mesh.name = "text";

    let canvas = document.createElement('canvas');

    let ctx = canvas.getContext('2d');



    let fontSize = 70;
    const text = this.type;
    let font = "LatoWebBlack";
    ctx.font = "extra-condensed bolder " + fontSize + "px " + font;
    let textWidth = this.getTextWidth(text, ctx.font);

    mesh.scale.set(Math.ceil(textWidth) / 10, 1, 8);
    canvas.width = Math.ceil(textWidth);
    canvas.height = 80;
    // ctx.strokeStyle = "black";
    ctx.fillStyle = 'white';
    // ctx.fillRect(0, 0, canvas.width, canvas.height);


    // ctx.lineWidth = 6;
    ctx.font = "extra-condensed bolder " + fontSize + "px " + font;

    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.fillText(text, canvas.width / 2, (canvas.height + Math.floor(fontSize * 0.7)) / 2);
    // ctx.strokeText(text, canvas.width / 2, (canvas.height + Math.floor(fontSize * 0.8)) / 2);
    // ctx.strokeRect(0, 0, canvas.width, canvas.height);
    // ctx.drawImage(this.image, 0, -canvas.height / 10, canvas.width, canvas.height * 1.2);

    if (!mesh.material.map) {
      mesh.material.map = new THREE.Texture(canvas);
    }
    mesh.material.map.image = canvas;

    mesh.material.map.needsUpdate = true;
    mesh.material.needsUpdate = true;

    mesh.name = "text";

    this.add(mesh);
    this.name = TextPost.Name;
    this.setLabelPos();
  }

  getRoot(): IObject3D {
    return this.parent;
  }

  setLabelPos() {
    let vect = [
      this.worldToLocal(new THREE.Vector3(6, 0, 0)),
      this.worldToLocal(new THREE.Vector3(0, 0, 6)),
      this.worldToLocal(new THREE.Vector3(-6, 0, 0)),
      this.worldToLocal(new THREE.Vector3(0, 0, -6))
    ];
    let mesh;
    this.children.filter(ch => ch.name === "text").forEach(ch => {
      mesh = ch;
    });
    for (let i = 0; i < 4; i++) {
      let x = vect[i].x * Math.cos(mesh.rotation.y) + vect[i].z * Math.sin(mesh.rotation.y);
      let z = vect[i].z * Math.cos(mesh.rotation.y) - vect[i].x * Math.sin(mesh.rotation.y);
      vect[i] = new THREE.Vector3(x, 0, z);
    }
    // let pos = mesh.getWorldPosition();
    // mesh.applyMatrix( this.matrixWorld );

    if (mesh) {
      switch (this.labelPos) {
        case "Above":
          mesh.position.add(vect[3]);
          break;
        case "Left Side":
          mesh.position.add(vect[2]);
          break;
        case "Right Side":
          mesh.position.add(vect[0]);
          break;
        case "Below":
          mesh.position.add(vect[1]);
          break;
        case "Center":
          break;
      }
    }
  }


  getTextWidth(text: string, font) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    ctx.font = font;
    const metrics = ctx.measureText(text);
    return metrics.width;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/textPost.ts